import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { checkHoursOfOperation } from './util/lavu';
import {
  getRestaurantDetails,
  getOrderDetails,
  dashboardData,
  getModeOfOrder,
  getDataName,
  getRestaurantHours,
} from './views/dashboard/reducer';
import DevTools from './config/DevTools';
import Header from './Header';
import Footer from './Footer';
import PasswordRecovery from './views/auth/passwordreset/PasswordRecovery';
import DuplicatLavuToGoName from './views/modals/DuplicatLavuToGoName';
import {
  loginGuestRequest,
  closeSignInPopUp,
  logoutUser,
  removeGuestUser,
} from './redux/actions/authenticationActions';
import { ToastContainer, ToastMessage } from './lib';
import {
  setLavutogoRefereName,
  reloadStore,
  setUserLocation,
  updateLocationDetails,
  merchantDetails,
  showMobileSidebar,
  merchantDataName,
  setOrderTimeIsValidState,
} from './views/dashboard/actions';
import { MERCHANT_DETAILS_URL } from './util/urls';
import NotFound from './views/common/NotFound';
import Invalid from './views/common/invalid';
import Loading from './views/common/Loading';
import { loadCategories } from './views/menu/actions';
import { loadMenuItems } from './actions/MenuItemsActions';
import './public/css/Dashboard.css';
import './public/css/model.css';
import { API_ERROR, cookieValue } from '../src/lib/helper';
import { AddClientThemeClasses } from './theme.js';
import { getRestaurantLocations } from './api/api';
import { SearchAvailableAddress } from './api/searchForAddress';
import RestaurantLocations from './views/orderType/RestaurantLocations';
import { get, isEmpty, find, groupBy, forEach } from 'lodash';
import TagManager from 'react-gtm-module';
import ReactGA from 'react-ga';
import IdleTimer from 'react-idle-timer';
import {
  GA_TRACKING_PREFIX,
  GA_GTM_PREFIX,
  TYPE_DELIVERY,
  TIME_OUT_MINUTES,
  DINING_OPTIONS,
} from './util/Constants';
import { getAlertifyHeader } from '../src/lib/helper';
import defaultMsg from '../src/translations/lang/en-US.json';
import { isRestaurantAvailable } from './lib/helper';
import moment from 'moment';
import SignInModal from './views/auth/SignInModal';
import { initSocket } from './socket/index';

var alertify = require('alertifyjs');

alertify.dialog('checkUserSessionAndRemove', function factory() {
  return {
    main: function(title, message, onRestaurantInfo, removeGuest) {
      this.message = message;
      if (this.message === '') {
        this.message = this.props.intl.formatMessage({
          id: 'inactive30',
          defaultMessage: defaultMsg.inactive30,
        });
      }
      this.title = title;
      this.onRestaurantInfo = onRestaurantInfo;
      this.removeGuest = removeGuest;
    },
    setup: function() {
      var buttons = [];
      buttons.push({
        text: (this.message = JSON.parse(localStorage.getItem('langVars'))[
          'yes'
        ]),
        key: 27,
        className: 'btn btn-ok bordered',
        invokeOnClose: false,
      });
      buttons.push({
        text: (this.message = JSON.parse(localStorage.getItem('langVars'))[
          'no'
        ]),
        className: 'btn btn-restaurant-info bordered',
      });
      return {
        buttons,
        options: {
          resizable: false,
          moveable: false,
          pinned: false,
          maximizable: false,
          closable: false,
          closableByDimmer: false,
        },
      };
    },
    prepare: function() {
      this.setHeader(this.title);
      this.setContent(
        `<div class="text-center order-success-container"><h4>${
          this.message
        }</h4></div>`
      );
    },
    callback: function(action) {
      if (action.index === 0) {
        this.removeGuest();
      }
      if (action.index === 1) {
        this.onRestaurantInfo();
      }
    },
  };
});
const ToastMessageFactory = React.createFactory(ToastMessage.animation);

class App extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.state = {
      showInitialModal: true,
      showModal: false,
      viewMobileOrderPanel: true,
      notFound: false,
      loading: true,
      notFoundCode: '',
      notFoundMessage: '',
      showOrderTypePopup: false,
      onloadCategories: false,
      signInCaller: 'header',
      checkForDuplicateLavuTogoName: true,
      forgotPasswordModal: false,
      forgotPasswordCallerType: '',
      isOnCheckout: this.props.location.pathname.includes('checkout'),
      restaurantLocations: false,
      isApiFailure: false,
      locationSet: '',
    };
    this.idleTimer = null;
    this.onIdle = this.onIdle.bind(this);

    this.isOnDashboard = this.isOnDashboard.bind(this);
    this.showForgotPasswordCaller = this.showForgotPasswordCaller.bind(this);
    this.isOrderTypeRequired = this.isOrderTypeRequired.bind(this);
    this.validateApiResponse = this.validateApiResponse.bind(this);
    this.enableGoogleAnalytics = this.enableGoogleAnalytics.bind(this);
    this.updateRestaurantAddress = this.updateRestaurantAddress.bind(this);
    this.clearData = this.clearData.bind(this);
    this.clearGuestData = this.clearGuestData.bind(this);
  }

  onIdle() {
    alertify.checkUserSessionAndRemove(
      getAlertifyHeader(
        this.props.intl.formatMessage({
          id: 'sessionTimeOut',
          defaultMessage: defaultMsg.sessionTimeOut,
        }),
        false,
        'center'
      ),
      this.props.intl.formatMessage({
        id: 'inactive30',
        defaultMessage: defaultMsg.inactive30,
      }),
      this.clearData,
      this.clearGuestData
    );
  }

  clearGuestData() {
    let cookieData = cookieValue('token');
    if (
      cookieData === null &&
      this.props.authData.loginUserDetails.guestUser !== null
    ) {
      this.props.dispatch(removeGuestUser());
    }
  }
  clearData() {
    this.props.dispatch(logoutUser('removeuser')).then(res => {
      window.location.href = '/' + localStorage.getItem('lavutoGoName');
    });
  }

  updateRestaurantAddress({ tokenId, jwt, dataname }) {
    if (
      !isEmpty(this.props.dashboardData.userSelectedLocation) &&
      !isEmpty(this.props.dashboardData.userLocation) &&
      !isEmpty(this.props.dashboardData.locationDetails)
    ) {
      SearchAvailableAddress({
        streetAddress: this.props.dashboardData.userSelectedLocation,
        dataname,
        diningOption: '',
        jwt,
        tokenId,
        rname: this.props.params.rname,
      }).then(
        function(apiResponse) {
          const restaurantNearByToUserLocations = get(
            apiResponse,
            'data.DataResponse.sourceaddress',
            false
          );
          if (restaurantNearByToUserLocations.length) {
            const locationData = groupBy(
              this.state.restaurantLocations,
              'dataname'
            );
            forEach(restaurantNearByToUserLocations, function(data, key) {
              restaurantNearByToUserLocations[key]['diningOption'] = get(
                locationData[data.dataname],
                '0.diningOption',
                ''
              );
            });
            this.props.dispatch(
              setUserLocation({
                address: this.props.dashboardData.userSelectedLocation,
                availableRestaurant: restaurantNearByToUserLocations,
              })
            );
            const filteredLocation = find(restaurantNearByToUserLocations, {
              id: this.props.dashboardData.locationDetails.id,
            });
            if (filteredLocation) {
              this.props.dispatch(updateLocationDetails(filteredLocation));
            }
          }
        }.bind(this)
      );
    }
  }

  enableGoogleAnalytics() {
    const {
      googleAnalyticCode = '',
      googleAnalyticTagManagementId = '',
    } = this.props;
    if (googleAnalyticTagManagementId) {
      if (
        googleAnalyticTagManagementId.toLowerCase().split('-')[0] ===
        GA_GTM_PREFIX
      ) {
        TagManager.initialize({ gtmId: googleAnalyticTagManagementId });
      }
    }
    if (googleAnalyticCode) {
      if (
        googleAnalyticCode.toLowerCase().split('-')[0] === GA_TRACKING_PREFIX
      ) {
        ReactGA.initialize(googleAnalyticCode);
        ReactGA.pageview(window.location.pathname + window.location.search);
      }
    }
  }

  validateApiResponse(apiResponse) {
    if (!apiResponse || apiResponse.status === 500) {
      this.setState({
        isApiFailure: true,
      });
      return false;
    } else {
      return apiResponse.json();
    }
  }

  showForgotPasswordCaller() {
    switch (this.state.forgotPasswordCallerType) {
      case 'Login':
        this.setState({
          forgotPasswordModal: false,
          showModal: true,
          forgotPasswordCallerType: '',
        });
        break;
      default:
        this.setState({
          forgotPasswordModal: false,
          showModal: false,
          forgotPasswordCallerType: '',
        });
        break;
    }
  }

  showForgotPasswordModal = type => {
    this.setState({
      forgotPasswordModal: true,
      showModal: false,
      forgotPasswordCallerType: type,
    });
  };

  checkOrderTime = () => {
    const { orderDetails, restaurantDetails } = this.props;

    // If now falls outside of order hours, trigger order is valid state
    const isWithinHours = checkHoursOfOperation({
      ...orderDetails,
      ...restaurantDetails,
    });
    if (!isWithinHours && orderDetails.isOrderTimeValid) {
      this.props.dispatch(setOrderTimeIsValidState(false));
    } else if (isWithinHours && !orderDetails.isOrderTimeValid) {
      this.props.dispatch(setOrderTimeIsValidState(true));
    }
  };

  timer = null;

  startTimer = () => {
    if (this.timer == null) {
      this.checkOrderTime();
      this.timer = setInterval(this.checkOrderTime, 1000);
    }
  };

  stopTimer = () => {
    if (this.timer != null) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  componentWillUpdate(nextProps) {
    if (nextProps.dashboardData.reloadStore) {
      nextProps.dispatch(reloadStore(false));
      this.setState({ loading: true });
      this.initApp();
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  handleDuplicateLavuTogoNameClick(refereLavuToGoName, e) {
    let self = this;
    let isSameRefere =
      refereLavuToGoName === this.props.dashboardData.dataName ? true : false;

    this.props
      .dispatch(
        setLavutogoRefereName(
          refereLavuToGoName,
          !isSameRefere,
          this.props.params.rname
        )
      )
      .then(e => {
        if (!isSameRefere) {
          self.setState({ loading: true });
          browserHistory.push('/' + self.props.params.rname);
          self.initApp();
        }
      });
  }

  loadMerchantDetails(tData, callBack) {
    this.updateRestaurantAddress(tData);
    fetch(
      MERCHANT_DETAILS_URL +
        'tokenId/' +
        tData.tokenId +
        '/dataname/' +
        tData.dataname +
        '/lavutogoname/' +
        tData.lavuToGoName,
      {
        method: 'GET',
        responseType: 'JSON',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Basic ' + btoa(tData.jwt),
        },
      }
    )
      .catch(error => {
        API_ERROR(error);
      })
      .then(res => this.validateApiResponse(res))
      .then(apiResponse => {
        const data = apiResponse.DataResponse;
        if (data) {
          if (data.status === 'F') {
            this.setPageNotFound();
          } else {
            this.setState({
              locationSet: data['ltg_treat_site_single_location'],
            });
            this.props.dispatch(merchantDetails(data)).then(() => {
              callBack();
            });
          }
        }
      });
  }

  setPageNotFound = () => {
    this.setState({
      loading: false,
      notFound: true,
      notFoundCode: '401',
    });
  };

  getTargetDataNameDetails(data) {
    let targetKey = 0;
    const { refereLavuTogoDataName } = this.props.dashboardData;
    if (typeof refereLavuTogoDataName === 'string') {
      for (let i = 0; i < data.length; i++) {
        if (data[i].dataname === refereLavuTogoDataName) {
          targetKey = i;
          break;
        }
      }
    }
    return data[targetKey];
  }

  loadToken = callBack => {
    this.props
      .dispatch(loginGuestRequest(this.props.params.rname))
      .then(fullGuestLogin => {
        const { guestToken, tokenId, jwt, restaurantLocation } = fullGuestLogin;
        // Set restaurant location data
        this.props.dispatch(merchantDataName(restaurantLocation));
        // Set in localStorage lavutoGoName
        localStorage.setItem('lavutoGoName', restaurantLocation.lavuToGoName);
        //----------------------------------------------------------------------------
        //  All this have to change to start using guestToken from new backend
        //----------------------------------------------------------------------------
        const params = {
          lavuToGoName: restaurantLocation.lavuToGoName,
          dataname: restaurantLocation.dataname,
          tokenId: tokenId,
          jwt: jwt,
        };
        getRestaurantLocations(params).then(locations => {
          this.setState(
            {
              restaurantLocations: get(
                locations,
                'data.DataResponse.restuarentLocations',
                false
              ),
            },
            () => {
              this.loadMerchantDetails(params, callBack);
            }
          );
        });
        //----------------------------------------------------------------------------
      })
      .catch(error => {
        API_ERROR(error);
        this.setState({ isApiFailure: true });
        this.setPageNotFound();
      });
  };

  isOnDashboard() {
    const { location } = this.props;
    const reqularExpression = new RegExp(
      `^\/${this.props.params.rname}\/{0,}$`
    );
    return reqularExpression.test(location.pathname);
  }

  loadRestaurantMenus() {
    const { dashboardData, tokenId, jwt } = this.props;
    const { merchantDetails, dataName, modeOfOrder } = dashboardData;

    const ltgDineInOption = get(merchantDetails, 'ltg_dine_in_option', null);
    let defaultDiningType = '';
    if (ltgDineInOption) {
      const parsedLtgDineInOption = ltgDineInOption.split(',');
      if (parsedLtgDineInOption.length > 0)
        defaultDiningType =
          parsedLtgDineInOption.indexOf(DINING_OPTIONS.Delivery) !== -1
            ? DINING_OPTIONS.Delivery
            : parsedLtgDineInOption[0];
    }

    this.props.dispatch(loadCategories(tokenId, dataName, true)).then(res => {
      document.title = `${res.mainMenuItemName} - ${
        merchantDetails.title
      } - Lavu To Go`;
      this.props
        .dispatch(
          loadMenuItems(
            res.subMenuItemClicked,
            modeOfOrder,
            tokenId,
            jwt,
            dataName,
            defaultDiningType
          )
        )
        .then(() => {
          if (this.state.loading === true) {
            this.setState({
              loading: false,
              onloadCategories: true,
            });
          }
        });
    });
  }

  componentWillMount() {
    if (this.props.params.rname === undefined) {
      this.setState({
        loading: false,
        notFound: true,
      });
    } else {
      this.initApp(() => {
        this.enableGoogleAnalytics();
      });
    }
  }

  initApp(callBack) {
    this.loadToken(() => {
      this.loadRestaurantMenus();
      if (callBack) {
        callBack();
      }
    });
  }

  /*
  * load default items with dining option Delivery
  * also show sign-up modal on request
  */
  componentWillReceiveProps(nextProps) {
    if (
      !this.state.loading &&
      (nextProps.dashboardData &&
        nextProps.dashboardData.dataName &&
        ((!this.state.onloadCategories && this.props.dashboardData.dataName) ||
          (!this.state.onloadCategories &&
            this.props.dashboardData.locationChanged === true &&
            this.props.guestToken &&
            this.props.dashboardData.dataName)))
    ) {
      if (
        nextProps.dashboardData.dataName !== this.props.dashboardData.dataName
      ) {
        this.props.dashboardData.dataName = nextProps.dashboardData.dataName;
      }
      this.loadRestaurantMenus();
    }

    if (nextProps.showSigninPopUp === true) {
      this.setState({
        showModal: true,
        signInCaller: nextProps.signInCaller,
      });
    }

    this.setState({
      isOnCheckout: this.props.location.pathname.includes('checkout'),
    });
  }

  open(signInCaller) {
    this.setState({
      showModal: true,
      signInCaller: signInCaller || this.state.signInCaller,
    });
  }

  close() {
    this.setState({
      showModal: false,
    });
    this.props.dispatch(closeSignInPopUp());
  }

  error = msg => {
    this.refs.app_container.error(msg);
  };

  success = msg => {
    this.refs.app_container.success(msg);
  };

  viewSidebar() {
    this.props.dispatch(showMobileSidebar());
  }

  isSafari() {
    return (
      navigator.userAgent.search('Safari') >= 0 &&
      navigator.userAgent.search('Chrome') < 0
    );
  }

  isFireFox() {
    return (
      navigator.userAgent.search('Firefox') >= 0 &&
      navigator.userAgent.search('Chrome') < 0
    );
  }

  isInternetExplorer() {
    return (
      navigator.appName === 'Netscape' &&
      navigator.userAgent.search('Chrome') < 0
    );
  }

  browser() {
    if (this.isSafari()) {
      return 'safari';
    } else if (this.isFireFox()) {
      return 'Firefox';
    } else if (this.isInternetExplorer()) {
      return 'IE';
    }
  }

  isOrderTypeRequired() {
    return (
      this.props.dashboardData.showOrderTypePopup ||
      (!this.props.modeOfOrder &&
        !this.props.dashboardData.orderTypePopupOnAddToCart) ||
      (this.props.modeOfOrder === TYPE_DELIVERY &&
        this.props.dashboardData.checkoutDiningChanged &&
        isRestaurantAvailable(this.props.restaurantHours, moment()))
    );
  }

  render() {
    const {
      guestToken,
      dashboardData,
      location,
      ltgSiteSingleLocation,
      children,
      params,
      themeBackground,
    } = this.props;
    const {
      loading,
      isApiFailure,
      notFound,
      notFoundCode,
      notFoundMessage,
      forgotPasswordModal,
      isOnCheckout,
      onloadCategories,
      restaurantLocations,
      showModal,
      signInCaller,
    } = this.state;
    const lavuTogoName = get(params, 'rname', '');

    if (themeBackground) AddClientThemeClasses(themeBackground);

    return (
      <IdleTimer
        ref={ref => {
          this.idleTimer = ref;
        }}
        element={document}
        onIdle={this.onIdle}
        timeout={TIME_OUT_MINUTES * 60 * 1000}
      >
        <div className={this.browser() ? this.browser() : 'Chrome'}>
          <ToastContainer
            toastMessageFactory={ToastMessageFactory}
            ref="app_container"
            className="toast-top-right"
          />
          {(loading || !guestToken) && !isApiFailure ? (
            <Loading />
          ) : notFound || isApiFailure ? (
            <div>
              {notFound ? (
                <NotFound code={notFoundCode} message={notFoundMessage} />
              ) : null}

              {isApiFailure ? <Invalid message={notFoundMessage} /> : null}
            </div>
          ) : (
            [
              <div className="app-container" key="app">
                {forgotPasswordModal ? (
                  <PasswordRecovery onClose={this.showForgotPasswordCaller} />
                ) : null}

                <DuplicatLavuToGoName
                  lavuTogoName={lavuTogoName}
                  closeSigin={this.close}
                  handleClick={e => this.handleDuplicateLavuTogoNameClick(e)}
                />
                {!isOnCheckout ? (
                  <Header
                    onloadCategories={onloadCategories}
                    showSigninModalCallback={signInCaller =>
                      this.open(signInCaller)
                    }
                    viewSidebarCallback={this.viewSidebar.bind(this)}
                    numberOfItemsInCart={get(
                      dashboardData,
                      'numberOfItemsInCart',
                      0
                    )}
                    cartPrice={get(dashboardData, 'cartPrice', 0)}
                    rname={lavuTogoName}
                    tip={get(dashboardData, 'tipPrice', 0)}
                    location={location}
                    pathname={get(location, 'pathname', '')}
                  />
                ) : null}
                <RestaurantLocations
                  locations={restaurantLocations}
                  rname={lavuTogoName}
                  show={this.isOrderTypeRequired()}
                  showMultipleLocations={ltgSiteSingleLocation}
                />

                {showModal ? (
                  <SignInModal
                    show={showModal}
                    onHide={this.close}
                    error={this.error}
                    success={this.success}
                    lavuToGoName={lavuTogoName}
                    signInCaller={signInCaller}
                    showForgotPasswordModal={this.showForgotPasswordModal}
                  />
                ) : null}
                {!window.devToolsExtension &&
                  process.env.NODE_ENV === 'development' && <DevTools />}
                {children}
              </div>,
              <Footer key="footer" />,
            ]
          )}
        </div>
      </IdleTimer>
    );
  }
}

function mapStateToProps(state) {
  const merchantDetails =
    state.dashboard.merchantDetails !== 'null'
      ? state.dashboard.merchantDetails
      : {};
  window.currencySymbol = merchantDetails.monitary_symbol;
  window.currencySymbolPosition = merchantDetails.monitory_symbol_position;
  window.decimalPoints = merchantDetails.disable_decimal;
  window.decimalSeparator = merchantDetails.decimal_separator;
  window.modalPopped = false;
  return {
    refereLavuTogoDataName: state.dashboard.refereLavuTogoDataName,
    showSigninPopUp: state.auth.showSigninPopUp,
    restaurantHours: getRestaurantHours(state),
    signInCaller: state.auth.signInCaller,
    authData: state.auth,
    dashboardData: dashboardData(state),
    tokenId: state.auth.tokenId,
    guestToken: state.auth.guestToken,
    themeBackground: merchantDetails.lavu_togo_theme,
    currencySymbol: merchantDetails.monitary_srestautrantsRowResultymbol,
    restaurantDetails: getRestaurantDetails(state),
    orderDetails: getOrderDetails(state),
    authenticated: state.auth.authenticated,
    modeOfOrder: getModeOfOrder(state),
    dataname: getDataName(state),
    menuArray: state.menuCategories.menuArray,
    googleAnalyticCode: get(
      merchantDetails,
      'ltg_google_analytics_tracking_id',
      false
    ),
    ltgSiteSingleLocation: get(
      merchantDetails,
      'ltg_treat_site_single_location',
      false
    ),
    googleAnalyticTagManagementId: get(
      merchantDetails,
      'ltg_google_tag_management_id',
      false
    ),
  };
}

App.propTypes = {
  intl: intlShape.isRequired,
};

export default connect(mapStateToProps)(injectIntl(App));



// WEBPACK FOOTER //
// ./src/App.js